package core.validation.validator

class IntMinValidator(
    private val minValue: Int,
    private val strict: Boolean = false
) : Validator<Int> {
    override val errorMessage: String
        get() = "Value must be greater than ${if (!strict) "or equal to " else ""}$minValue"

    override fun validate(value: Int): Boolean {
        return if (strict) value > minValue else value >= minValue
    }
}
